import { openOnboardingPaywall } from "@components/ChatOnboarding/openOnboardingPaywall";
import { callEdgenModalWhenRootReadyAsync } from "@components/EdgenModal/waitForEdgenModalRoot";
import {
  trackPlanCalendarLockTap,
  trackPlanDashboardUnlockTap,
} from "@screens/plan/planActivityAnalytics";
import { trackOnboardingAnalytics } from "@/src/hooks/onboarding/onboardingAnalytics";

export type PlanTabUnpaidUnlockSurface =
  "plan_tab_direct" | "calendar_lock" | "dashboard_lock";

/** Plan Tab 非会员页内 Unlock — V3 onboarding paywall */
export async function openPlanTabUnpaidUnlock(
  isPC: boolean,
  surface: PlanTabUnpaidUnlockSurface = "plan_tab_direct",
): Promise<void> {
  if (surface === "calendar_lock") {
    trackPlanCalendarLockTap();
  } else if (surface === "dashboard_lock") {
    trackPlanDashboardUnlockTap();
  }
  trackOnboardingAnalytics("ob_unpaid_plan_unlock_click", { entry: surface });
  await callEdgenModalWhenRootReadyAsync(() => openOnboardingPaywall(isPC));
}
